// extracted by mini-css-extract-plugin
module.exports = {"colorGreyLight":"#CBD5E0","colorPrimary":"#276749","colorPrimaryLight":"#38A169","colorWhite":"#FFFFFF"};